import axios from 'axios';
import { API_ENDPOINTS } from '../assets/api/endpoints';

type SocketTokenResponse = { token: string };

/**
 * Fetches a JWT intended only for WebSocket/STOMP connect headers.
 */
export async function fetchSocketToken(): Promise<string | null> {
	try {
		const { data } = await axios.post<SocketTokenResponse>(API_ENDPOINTS.socketToken, {});
		return typeof data?.token === 'string' && data.token.length > 0 ? data.token : null;
	} catch (e) {
		console.error('fetchSocketToken failed:', e);
		return null;
	}
}
